const ContentEducation = () =>
  import(/* webpackChunkName: "contentEducation" */ '../views/ContentEducation.vue')
const ContentEducationDetail = () =>
  import(/* webpackChunkName: "contentEducationDetail" */ '../views/ContentEducationDetail.vue')

const EducationRoute = [
  {
    path: '/education',
    name: 'education',
    component: ContentEducation,
    meta: {
      requiresAuth: true,
      hiddeMenu: false,
      navBar: true,
      navBarBack: false,
      title: 'Content',
      backLink: 'dashboard',
    },
  },
  {
    path: '/education/detail/:id',
    name: 'educationdetail',
    component: ContentEducationDetail,
    meta: {
      requiresAuth: true,
      hiddeMenu: true,
      navBar: true,
      navBarBack: true,
      title: 'Content Detail',
      backLink: 'education',
    },
  },
]

export default EducationRoute
